const Joi = require("joi");

const validateQueryParams = (queryParamsData) => {
  const queryParam = {
    // authToken: Joi.string().invalid("{authToken}").required(),
    clientId: Joi.string().invalid("{clientId}").required(),
  };

  const schema = Joi.object().keys(queryParam).unknown(true);
  return schema.validate(queryParamsData);
};

export default validateQueryParams;
